/**
 * Wordmark shared by the app bar and the welcome dialog (larger via .welcome-brand):
 * "SID2MIDI Web" followed on the same line by the smaller "for Commodore 64 SID tunes".
 */
export function Brand({ titleId, as: Tag = 'div' }: { titleId?: string; as?: 'div' | 'h1' }) {
  return (
    <div className="brand-line">
      <Tag className="brand" id={titleId}>
        <span className="sid">SID</span>
        <span className="word">2MIDI</span> <span className="web">Web</span>
      </Tag>
      <span className="brand-sub">
        <em>for</em> <span className="c64">Commodore 64</span> <em>SID tunes</em>
      </span>
    </div>
  );
}
